import React, { ReactNode } from "react";
import FlexBox from "../../../Components/FlexBox/FlexBox";
import Typography from "../../../Foundation/Typography/Typography";
import { IThemeMode } from "../../../Themes/defaultTheme";

interface IFooterItemProps {
  title?: ReactNode;
  children?: ReactNode;
  mode?: IThemeMode;
}

const FooterItem = (props: IFooterItemProps) => {
  const { title, children, mode = "light" } = props;

  return (
    <FlexBox direction="column" gap={24}>
      {title && (
        <Typography
          variant={mode === "dark" ? "h5" : "ui2"}
          color={mode === "dark" ? "white" : "placeholder"}
        >
          {title}
        </Typography>
      )}

      {/* content */}
      <div>{children}</div>
    </FlexBox>
  );
};

export default FooterItem;
